var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$route.path.includes('/auth/'))?_c('el-footer',{attrs:{"height":"35px"}},[_vm._v("\n  © "+_vm._s(new Date().getFullYear())+" SyncVault Admin\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }